import './report-menu.scss'

import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import Component from 'vue-class-component';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { DELETE_CURRENT_REPORT_TOPIC, OPEN_CLOSE_REPORT_SCREEN_TOPIC, OPEN_PDF_OVERVIEW_TOPIC, OPEN_SIGNATURE_MODULE_TOPIC, SAVE_CURRENT_REPORT_TOPIC, TOGGLE_MENU_TOPIC } from '../../../busTopics';
import { router, Routes } from '../../../router';

@Component({
    template: require('./report-menu.html')
})
export class ReportMenu extends ReactiveVue {

    private isPopupVisible = false;

    // Icons
    private crossIcon = faTimes;
    private checkIcon = faCheck;

    public saveReport() {
        this.emitOnBus(SAVE_CURRENT_REPORT_TOPIC)
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    public openReportOverview() {
        this.emitOnBus(OPEN_PDF_OVERVIEW_TOPIC);
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    public openSignatureModule() {
        this.emitOnBus(OPEN_SIGNATURE_MODULE_TOPIC);
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    public openCloseModuleScreen() {
        this.emitOnBus(OPEN_CLOSE_REPORT_SCREEN_TOPIC);
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    public showDeleteValidationPopup(value: boolean) {
        this.isPopupVisible = value
    }

    public deleteReport() {
        this.emitOnBus(TOGGLE_MENU_TOPIC);
        this.emitOnBus(DELETE_CURRENT_REPORT_TOPIC);
        router.push({ name: Routes.CONDITION_REPORT_HOME });
    }

}